import { useEffect, useState } from 'react';

const useAnimations = (animation) => {
  const [toggled, setToggled] = useState(false);

  useEffect(() => {
    if (animation && animation.animationCallback && toggled) {
      animation.animationCallback(true);
      animation.updateTrimInnerKey();
      setToggled(false);
    }

    return () => {
      if (animation && animation.animationCallback && !toggled) {
        animation.animationCallback();
      }
    };
  }, [toggled]);

  return { toggled, setToggled };
};

export default useAnimations;
